import { useState } from "react";
import { Button, TextFieldProps } from "@chemaxon/design-system";
import { TextField } from "@chemaxon/design-system";
import FormLayoutVertical from "@chemaxon/terminus-client/ui/components/form/FormLayoutVertical";
import FormActions from "@chemaxon/terminus-client/ui/components/form/FormActions";
import { Group } from "@chemaxon/terminus-client/ui/models/Group";
import { useGetTeamMembers } from "@chemaxon/terminus-client/ui/services/TeamMemberService";
import { FormControl } from "@mui/material";
import GroupMembersContainer from "@chemaxon/terminus-client/ui/components/groups/GroupMembersContainer";

enum FormField {
  groupName = "groupName",
  memberIds = "memberIds",
}

type FormData = {
  groupName: string;
  memberIds: number[];
};

export default function GroupDetails(props: Props) {
  const teamMembers = useGetTeamMembers().data;

  const [formData] = useState<FormData>(props.group);

  const getGeneralProps = (): TextFieldProps => {
    return {
      margin: "normal",
      fullWidth: true,
    };
  };

  const getGeneralInputProps = (field: FormField) => ({
    id: field,
    name: field,
    value: formData[field],
    autoComplete: "off",
  });

  const renderNameField = () => {
    return (
      <TextField
        label="Group name"
        {...getGeneralProps()}
        InputProps={getGeneralInputProps(FormField.groupName)}
        disabled
        required
      />
    );
  };

  const renderMembersField = () => {
    return (
      <GroupMembersContainer
        groupMemberIds={formData.memberIds ?? []}
        teamMembers={teamMembers ?? []}
        {...getGeneralProps()}
        disabled
      />
    );
  };

  const renderCancelButton = () => {
    return (
      <Button colorVariant="secondary" onClick={props.onCancel}>
        Cancel
      </Button>
    );
  };

  return (
    <form id="groupEditor">
      <FormLayoutVertical>
        <FormControl>{renderNameField()}</FormControl>
        {renderMembersField()}

        <FormActions justifyContent="flex-end">
          {renderCancelButton()}
        </FormActions>
      </FormLayoutVertical>
    </form>
  );
}

type Props = {
  group: Group;
  onCancel: () => void;
};
